import { Box, Text, VStack, HStack, Stack } from "@chakra-ui/react";
import CurrencyInput from "react-currency-input-field";
import WhiteBgInput from "../WhiteBgInput";

export interface BudgetData {
  type?: "daily" | "lifetime" | string;
  amount?: {
    amount?: number | null;
    currency?: string;
  };
}

export interface BudgetSelectorProps {
  value?: BudgetData;
  onChange: (budget: BudgetData) => void;
  currency?: string;
  disabled?: boolean;
  budgetTypeDisabled?: boolean;
}

const BudgetSelector = ({
  value,
  budgetTypeDisabled = false,
  onChange,
  currency = "USD",
  disabled = false,
}: BudgetSelectorProps) => {
  const handleTypeChange = (type: "daily" | "lifetime") => {
    onChange({
      ...value,
      type,
    });
  };

  const handleAmountChange = (amountValue: string | undefined) => {
    onChange({
      ...value,
      amount: {
        amount: amountValue ? parseFloat(amountValue) : null,
        currency,
      },
    });
  };

  // Use default values for missing properties
  const budgetType = value?.type || "daily";
  const budgetAmount = value?.amount?.amount || null;
  const budgetCurrency = value?.amount?.currency || currency;

  return (
    <Box
      p={4}
      flexGrow={1}
      h="full"
      borderRadius="xl"
      border="1px solid"
      borderColor="gray.200"
      bg="white"
      shadow="md"
      w="full"
    >
      <Stack w="full" spacing={1}>
        <Text fontWeight={"semibold"} w="full">
          Budget strategy
        </Text>
        <HStack w="full" justifyContent="space-between">
          <Box
            rounded="md"
            p={2}
            py={3}
            w="full"
            pointerEvents={budgetTypeDisabled ? "none" : "auto"}
            border="2px solid"
            fontWeight="medium"
            textAlign="center"
            borderColor={budgetType === "daily" ? "blue.500" : "gray.200"}
            onClick={() => !disabled && handleTypeChange("daily")}
            cursor={disabled ? "not-allowed" : "pointer"}
            opacity={budgetTypeDisabled || disabled ? 0.6 : 1}
          >
            Daily budget
          </Box>
          <Box
            rounded="md"
            pointerEvents={budgetTypeDisabled ? "none" : "auto"}
            border="2px solid"
            textAlign="center"
            borderColor={budgetType === "lifetime" ? "blue.500" : "gray.200"}
            p={2}
            py={3}
            fontWeight="medium"
            w="full"
            onClick={() => !disabled && handleTypeChange("lifetime")}
            cursor={disabled ? "not-allowed" : "pointer"}
            opacity={budgetTypeDisabled || disabled ? 0.6 : 1}
          >
            Total budget
          </Box>
        </HStack>
        <CurrencyInput
          // @ts-ignore
          w="100%"
          py={6}
          placeholder="$"
          defaultValue={budgetAmount?.toString()}
          disabled={disabled}
          onValueChange={handleAmountChange}
          intlConfig={{
            locale: "en-US",
            currency,
          }}
          customInput={WhiteBgInput}
          step={1}
        />
      </Stack>
    </Box>
  );
};

export default BudgetSelector;
